import { render, staticRenderFns } from "./sendContent.vue?vue&type=template&id=432901e4&scoped=true"
import script from "./sendContent.vue?vue&type=script&lang=js"
export * from "./sendContent.vue?vue&type=script&lang=js"
import style0 from "./sendContent.vue?vue&type=style&index=0&id=432901e4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "432901e4",
  null
  
)

export default component.exports